import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Components
import { NotFoundComponent } from './static/not-found/not-found.component';
import { PrivateComponent } from './private/private.component';
import { canAccessGuard } from './auth/guards/access.guard';

const routes: Routes = [
  {
    path: 'autenticacion',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'map',
    canActivate: [canAccessGuard],
    data: {
      roles: ['ROLE_MAINTENANCE', 'ROLE_SUBCONTRACT'],
    },
    loadChildren: () => import('./status-map/status-map.module').then(m => m.StatusMapModule),
  },
  {
    // El mapa de SIMs se registra a nivel raíz (fuera del PrivateComponent) para
    // pintarse a pantalla completa con su propio shell, igual que el status-map.
    path: 'sims/map',
    canActivate: [canAccessGuard],
    data: {
      roles: ['ROLE_MANAGER'],
    },
    loadChildren: () => import('./sims/sim-map/sim-map.module').then(m => m.SimMapModule),
  },
  {
    path: '',
    component: PrivateComponent,
    canActivate: [canAccessGuard],
    children: [
      {
        path: 'home',
        loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
        canActivate: [canAccessGuard],
        data: {
          roles: ['ROLE_MANAGER'],
        },
      },
      {
        path: 'estadisticas',
        loadChildren: () => import('./stats/stats.module').then(m => m.StatsModule),
      },
      {
        path: 'alertas',
        loadChildren: () => import('./alerts/alerts.module').then(m => m.AlertsModule),
      },
      {
        path: 'tarjetas',
        loadChildren: () => import('./cards/cards.module').then(m => m.CardsModule),
        canActivate: [canAccessGuard],
        data: {
          id: 'tarjetas',
          roles: ['ROLE_CUSTOMER_ACL'],
        },
      },
      {
        path: 'informes',
        loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
        canActivate: [canAccessGuard],
        data: {
          id: 'informes',
          requireCustomer: true,
          roles: ['ROLE_CUSTOMER'],
        },
      },
      {
        path: 'analisis-uso',
        loadChildren: () => import('./usages/usages.module').then(m => m.UsagesModule),
        canActivate: [canAccessGuard],
        data: {
          id: 'analisis-uso',
          requireCustomer: true,
          roles: ['ROLE_CUSTOMER_ACL'],
        },
      },
      {
        path: 'sims',
        loadChildren: () => import('./sims/sims.module').then(m => m.SimsModule),
        canActivate: [canAccessGuard],
        data: {
          id: 'sims',
          roles: ['ROLE_MANAGER'],
          headerData: { title: 'Sims' },
        },
      },
      {
        path: 'seguridad',
        loadChildren: () => import('./security/security.module').then(m => m.SecurityModule),
        canActivate: [canAccessGuard],
        data: {
          id: 'seguridad',
          roles: ['ROLE_ROOT'],
          headerData: { title: 'Seguridad' }
        },
      },
      {
        path: 'sims',
        loadChildren: () => import('./sims/sims.module').then(m => m.SimsModule),
        canActivate: [canAccessGuard],
        data: {
          id: 'sims',
          roles: ['ROLE_MANAGER'],
          headerData: { title: 'Sims' }
        },
      },
      {
        path: 'configuracion',
        loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
        data: {
          headerData: { title: 'Configuración' },
          roles: ['ROLE_MANAGER'],
        },
        canActivate: [canAccessGuard],
        // children: [
        //   {
        //     path: 'seguridad',
        //     loadChildren: () => import('./security/security.module').then(m => m.SecurityModule),
        //     data: {
        //       roles: ['ROLE_ROOT'],
        //       headerData: { title: 'Seguridad' }
        //     }
        //   },
        //   {
        //     path: 'configuracion',
        //     loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule),
        //     data: {
        //       roles: ['ROLE_MANAGER'],
        //       headerData: { title: 'Configuración' }
        //     }
        //   },
        // ],
      },
      {
        path: 'clientes',
        loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule),
      },
      {
        path: 'equipos',
        loadChildren: () => import('./equipments/equipments.module').then(m => m.EquipmentsModule),
      },
      {
        path: 'comunicaciones-mqtt',
        loadChildren: () => import('./mqtt/mqtt.module').then(m => m.MqttModule),
      },
      {
        path: 'release-notes',
        loadChildren: () => import('./release-notes/release-notes.module').then(m => m.ReleaseNotesModule),
      },
      { path: '', redirectTo: '/map', pathMatch: 'full' },
    ]
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
